export const format = (sec:number) => {
  const hours = parseInt(String(sec / (60 * 60)), 10)
  const minutes = parseInt(String((sec - (hours * 60 * 60)) / 60), 10)
  const seconds = sec - (hours * 60 * 60) - (minutes * 60)
  function completion (num:number) {
    return num > 9 ? num : (String(0) + num)
  }
  return `${completion(hours)}:${completion(minutes)}:${completion(seconds)}`
}